import { render, staticRenderFns } from "./cardRemovalOperationList.vue?vue&type=template&id=4b217984&scoped=true"
import script from "./cardRemovalOperationList.vue?vue&type=script&lang=js"
export * from "./cardRemovalOperationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b217984",
  null
  
)

export default component.exports